// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Sidebar_textarea__3mQKX","dropdown":"Sidebar_dropdown__3F5-9"};